import { useLanguage } from "@/components/language-provider";
import { LegalLayout } from "@/components/legal-layout";
import { MailLink, useContact } from "@/lib/website-settings";

export default function License() {
  const { language } = useLanguage();
  // Admin > Contatos in the app (blank there = the contact e-mail).
  const contact = useContact();

  if (language === "es") {
    return (
      <LegalLayout title="Acuerdo de licencia">
        <p className="text-muted-foreground text-sm mb-8">Última actualización: enero de 2026. Traducción al español; en caso de divergencia, prevalece la versión en portugués.</p>
        <h2>1. Concesión de la licencia</h2>
        <p>FillSign le otorga una licencia no exclusiva, intransferible y revocable para usar el Servicio conforme a estos términos y a su plan de suscripción.</p>
        <h2>2. Restricciones</h2>
        <p>Usted no puede aplicar ingeniería inversa, descompilar ni desensamblar ninguna parte del Servicio. Se prohíbe redistribuir el software o la API sin autorización por escrito.</p>
        <h2>3. Propiedad intelectual</h2>
        <p>Todos los derechos, títulos e intereses sobre el Servicio, incluidos los modelos de IA, la interfaz y la marca, pertenecen a FillSign. Su contenido sigue siendo de su propiedad.</p>
        <h2>4. Plugin para Dynamics 365</h2>
        <p>El plugin de FillSign para Microsoft Dynamics 365 se licencia por separado. Su uso requiere una suscripción activa de FillSign y una licencia válida de Dynamics 365.</p>
        <h2>5. Uso de la API</h2>
        <p>El acceso a la API se otorga según su plan de suscripción. El uso excesivo o abusivo puede generar limitación de solicitudes o suspensión.</p>
        <h2>6. Terminación</h2>
        <p>Esta licencia termina automáticamente al cancelar su suscripción o al incumplir estos términos.</p>
        <h2>7. Contacto</h2>
        <p>Para preguntas sobre licencias, escríbanos a <MailLink email={contact.legalEmail} />.</p>
      </LegalLayout>
    );
  }

  if (language === "en") {
    return (
      <LegalLayout title="License Agreement">
        <p className="text-muted-foreground text-sm mb-8">Last updated: January 2026</p>
        <h2>1. License Grant</h2>
        <p>FillSign grants you a non-exclusive, non-transferable, revocable license to use the Service in accordance with these terms and your subscription plan.</p>
        <h2>2. Restrictions</h2>
        <p>You may not reverse engineer, decompile, or disassemble any part of the Service. Redistribution of the software or API without written consent is prohibited.</p>
        <h2>3. Intellectual Property</h2>
        <p>All rights, title, and interest in the Service, including the AI models, user interface, and branding, belong to FillSign. Your content remains your property.</p>
        <h2>4. Dynamics 365 Plugin</h2>
        <p>The FillSign plugin for Microsoft Dynamics 365 is licensed separately. Its use requires an active FillSign subscription and a valid Dynamics 365 license.</p>
        <h2>5. API Usage</h2>
        <p>API access is granted per your subscription plan. Excessive or abusive use may result in rate limiting or suspension.</p>
        <h2>6. Termination</h2>
        <p>This license terminates automatically upon cancellation of your subscription or violation of these terms.</p>
        <h2>7. Contact</h2>
        <p>For licensing questions, contact us at <MailLink email={contact.legalEmail} />.</p>
      </LegalLayout>
    );
  }

  return (
    <LegalLayout title="Acordo de Licença">
      <p className="text-muted-foreground text-sm mb-8">Última atualização: Janeiro de 2026</p>
      <h2>1. Concessão de Licença</h2>
      <p>O FillSign concede a você uma licença não exclusiva, intransferível e revogável para usar o Serviço conforme estes termos e seu plano de assinatura.</p>
      <h2>2. Restrições</h2>
      <p>Você não pode fazer engenharia reversa, descompilar ou desmontar qualquer parte do Serviço. A redistribuição do software ou API sem consentimento por escrito é proibida.</p>
      <h2>3. Propriedade Intelectual</h2>
      <p>Todos os direitos, títulos e interesses no Serviço, incluindo modelos de IA, interface e marca, pertencem ao FillSign. Seu conteúdo permanece sua propriedade.</p>
      <h2>4. Plugin Dynamics 365</h2>
      <p>O plugin FillSign para Microsoft Dynamics 365 é licenciado separadamente. Seu uso requer uma assinatura ativa do FillSign e uma licença válida do Dynamics 365.</p>
      <h2>5. Uso da API</h2>
      <p>O acesso à API é concedido conforme seu plano de assinatura. Uso excessivo ou abusivo pode resultar em limitação ou suspensão.</p>
      <h2>6. Rescisão</h2>
      <p>Esta licença é rescindida automaticamente com o cancelamento da assinatura ou violação destes termos.</p>
      <h2>7. Contato</h2>
      <p>Para questões de licenciamento, entre em contato pelo email <MailLink email={contact.legalEmail} />.</p>
    </LegalLayout>
  );
}
